import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { withProps } from 'recompose';
import cx from 'classnames';
import produce from 'immer';
import _noop from 'lodash/noop';
import _property from 'lodash/property';
import _identity from 'lodash/identity';
import _set from 'lodash/set';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import selectorWithoutMemoize from '@tekion/tekion-base/utils/selectorWithoutMemoize';
import ACTION_TYPES from '../../../organisms/FormBuilder/constants/actionTypes';

// Helpers
import { getCellOnAction, getMapCellPropsToComponentProps, getColumnId } from '../TableInputField.helpers';
import { getPathToBeUpdated } from '../utils/tableStateHelpers';
var getComponentProps = function getComponentProps(props) {
  var mapCellPropsToComponentProps = getMapCellPropsToComponentProps(props) || _noop;
  return mapCellPropsToComponentProps(props);
};
var getRestTdProps = _property('tdProps.rest');
var getOnChangeValueGetter = _property('column.getValueFromOnChange');
var defaultOnChangeValueGetter = function defaultOnChangeValueGetter(nestingPath, params) {
  return _identity(params);
};
var makeOnAction = function makeOnAction(props) {
  return function () {
    var nestingPath = props.nestingPath;
    var onAction = getCellOnAction(props);
    var onChangeValueGetter = getOnChangeValueGetter(props) || defaultOnChangeValueGetter;
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    var value = onChangeValueGetter.apply(void 0, [nestingPath].concat(params, [props]));
    var column = props.column,
      original = props.original;
    var pathToUpdate = "".concat(getPathToBeUpdated(nestingPath));
    var newRowValue = produce(original, function (rowVal) {
      return _set(rowVal, "".concat(column.id), value);
    });
    onAction({
      type: ACTION_TYPES.ON_FIELD_CHANGE,
      payload: {
        value: value,
        id: getColumnId(props),
        nestingPath: props.nestingPath,
        params: params,
        additional: {
          updatedValue: newRowValue,
          pathToUpdate: pathToUpdate
        }
      }
    });
  };
};
var getCellRendererProps = function getCellRendererProps() {
  var componentProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var tdProps = arguments.length > 1 ? arguments[1] : undefined;
  var onAction = arguments.length > 2 ? arguments[2] : undefined;
  var id = arguments.length > 3 ? arguments[3] : undefined;
  var generalOnAction = arguments.length > 4 ? arguments[4] : undefined;
  return _objectSpread(_objectSpread(_objectSpread({
    menuPortalTarget: document.body,
    menuPosition: 'fixed',
    menuPlacement: 'auto'
  }, componentProps), tdProps), {}, {
    id: "".concat(id, "_").concat(componentProps.index),
    onChange: onAction,
    onAction: generalOnAction,
    className: cx(componentProps.className, 'full-width')
  });
};
var makeCellRendererProps = selectorWithoutMemoize([getComponentProps, getRestTdProps, makeOnAction, getColumnId, getCellOnAction], getCellRendererProps);
var makeCellRenderer = withProps(makeCellRendererProps);
export default makeCellRenderer;